import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import alertProvider from "src/providers/alert-provider";
import type { ListAlertsParams, PaginatedAlertsResponse } from "src/types";

const alertsQueries = {
	listAlerts: (params: ListAlertsParams) => {
		return useQuery<PaginatedAlertsResponse>({
			queryKey: ["alerts", params],
			queryFn: () => alertProvider.listAlerts(params),
			staleTime: 30_000,
		});
	},

	acknowledgeAlert: () => {
		const queryClient = useQueryClient();

		return useMutation({
			mutationFn: (alertId: number | string) =>
				alertProvider.acknowledgeAlert(alertId),
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: ["alerts"] });
			},
		});
	},

	resolveAlert: () => {
		const queryClient = useQueryClient();

		return useMutation({
			mutationFn: (alertId: number | string) =>
				alertProvider.resolveAlert(alertId),
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: ["alerts"] });
			},
		});
	},
};

export default alertsQueries;
